import React, { useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { IoMdLink } from "react-icons/io";
import ModalImage from "react-modal-image";
import { useSelector } from "react-redux";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import axios from "axios";
import { FiX } from "react-icons/fi";
import { MdAdd, MdDeleteOutline } from "react-icons/md";
import { useTranslation } from "react-i18next";

const PopupShare = ({
  handleClose,
  Url,
  isOpen,
  isHours,
  setIsHours,
  setIsOpen,
}) => {

  const { t } = useTranslation();
  const userData = useSelector((state) => state?.auth?.user?.user);
  const [copyText, setCopyText] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Images, setImages] = useState([]);
  const [files, setfiles] = useState([]);
  const [IsUpload, setIsUpload] = useState(false);
  const [showRes, setShowRes] = useState("");
  const [error, setError] = useState("");
  const timezones =
    Intl.supportedValuesOf && Intl.supportedValuesOf("timeZone")
      ? Intl.supportedValuesOf("timeZone")
      : [
        "UTC",
        "America/New_York",
        "America/Los_Angeles",
        "Asia/Kolkata",
        "Europe/London",
        "Europe/Berlin",
        "Australia/Sydney",
        // Add more timezones if needed
      ];

  const [selectedTimezone, setSelectedTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const inputFile = useRef(null);

  // to open file explore
  const openInputFile = (e) => {
    inputFile.current.click();
  };
  // to display image
  const handleImageChange = (e) => {
    setShowRes("");
    inputFile.current.click();
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setfiles((prev) => [...prev, ...files]);
      const imageUrls = files.map((file) => URL.createObjectURL(file));
      setImages((prev) => [...prev, ...imageUrls]);

      setIsUpload(true);
    }
  };
  const UploadImage = () => {
    setLoading(true);
    let data = new FormData();
    files.forEach((file, index) => {
      data.append(`file${index}`, file);
    });
    data.append(
      "albumName",
      userData.type === true ? "Business-Gallery" : "Personal-Gallery"
    );
    data.append("user", userData?._id);
    let config = {
      method: "post",
      url: Server2 + "/users/upload-gallery-images",
      data: data,
    };
    axios(config)
      .then(function (response) {
        setShowRes("Uploaded Sucessfully");
        console.log(response.data);
        setLoading(false);
        setTimeout(() => {
          setShowRes("");
          handleClose();
        }, 3000);
      })
      .catch(function (err) {
        console.log(err);
        setLoading(false);
        setShowRes("Failed to upload");
        setTimeout(() => {
          setShowRes("");
        }, 1000);
      });
  };
  const UploadApiOpeningHour = async () => {
    var data = {
      id: userData._id,
      businessHours: schedule,
      timeZone: selectedTimezone,
    };

    console.log(data, "data...");
    let config = {
      method: "POST",
      url: Server2 + "/users/business-hours",
      data: data,
    };
    await axios(config)
      .then((response) => {
        console.log(response.data, "resData");
        if (response.data.user.status === 200) {
          setError("Successfully updated");
        }
        setTimeout(() => {
          setError("");
        }, 3000);
      })
      .catch((err) => {
        console.log(err, "error upload opening hours");
        setError("Ops! not updated");
        setTimeout(() => {
          setError("");
        }, 3000);
      });
  };
  const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const [schedule, setSchedule] = useState(
    days.map((day) => ({
      day,
      isOff: false,
      timeSlots: [{ opening: "09:00", closing: "17:00" }],
    }))
  );

  const handleToggle = (day) => {
    setSchedule((prev) =>
      prev.map((d) =>
        d.day === day ? { ...d, isOff: !d.isOff } : d
      )
    );
  };

  const handleTimeChange = (day, index, field, value) => {
    setSchedule((prev) => prev.map((d) => d.day === day ?
      {
        ...d,
        timeSlots: d.timeSlots.map((slot, i) => i === index ? { ...slot, [field]: value } : slot ),
      }
      : d
      )
    );
  };

  const addTimeSlot = (day) => {
    setSchedule((prev) =>
      prev.map((d) => 
        d.day === day ? d.timeSlots.length < 2 ? {
          ...d,
          timeSlots: [
            ...d.timeSlots,
            { opening: "09:00", closing: "17:00" },
          ],
        } : d // Don't add more if already 2
        : d
      )
    );
  };

  const removeTimeSlot = (day, index) => {
    setSchedule((prev) =>
      prev.map((d) => d.day === day ? 
        { 
          ...d, timeSlots: d.timeSlots.length > 1 ?
              d.timeSlots.filter((_, i) => i !== index) 
            : [{ opening: "09:00", closing: "17:00" }] 
        } 
        : d
      )
    );
  };
  // const remainingDays = days.filter(
  //   (day) => !BusinessDays.includes(day.value)
  // );
  return (
    <div className="popup-box">
      <div
        className="box"
        style={{
          marginTop: isOpen === true ? "calc(100vh - 80vh - 20px)" : "100px",
          padding: isOpen === true ? "40px 20px" : "20px",
          maxHeight: 700, overflow: 'auto'
        }}
      >
        {isOpen === true ? (
          isHours === 1 ? (
            <>
              <h5 className="ms-4 ps-1 my-3">{t('shareProfile')}</h5>
              <div>
                <input
                  name="text"
                  value={Url}
                  isOff
                  className="form-control"
                  style={{ width: "90%", height: "45px", margin: "10px 5%" }}
                />
              </div>
              {/* <div>{Url.length> 10? `${Url.substring(0, 35)}...` :Url}</div> */}
              <div
                className=""
                style={{
                  width: "90%",
                  margin: "25px 5%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <CopyToClipboard text={Url}>
                  <button
                    onClick={() => setCopyText(true)}
                    className={
                      copyText === true
                        ? "bs-gray-400 text-primary rounded-3"
                        : "bg-white text-primary rounded-3"
                    }
                    style={{
                      border: "0.5px solid grey",
                      fontSize: "14px",
                      width: "23%",
                      padding: "10px",
                    }}
                  >
                    <IoMdLink size={20} />{" "}
                    {copyText === true ? "Copied" : "Copy Link"}
                  </button>
                </CopyToClipboard>
                <button
                  className="bg-primary text-white rounded-3 border-0"
                  style={{ fontSize: "14px", width: "23%", padding: "10px" }}
                  onClick={() => {
                    handleClose();
                    setIsHours(1);
                  }}
                >
                  {t('done')}
                </button>
              </div>
            </>
          ) : (
            <>
              <h4 className="my-3 text-center text-bold text-dark">
                Business Hours
              </h4>
              {error.length > 0 ? (
                <h5
                  className="text-success text-center"
                  style={{ fontSize: "16px" }}
                >
                  {error}
                </h5>
              ) : null}
              <div className="w-100">
                <div className="container d-flex flex-column align-items-center">

                  <div className="text-start" style={{width: '70%'}}>
                    <div>
                      <p className="fs-5 text-dark mt-2" style={{ marginBottom: "2px" }}>
                       {t('timeZone')} : {selectedTimezone}
                      </p>
                      <select
                        className="form-select"
                        value={selectedTimezone}
                        onChange={(e) => setSelectedTimezone(e.target.value)}
                        style={{
                          width: "100%",
                          backgroundColor: "#ECECEC",
                        }}
                      >
                        {timezones.map((tz) => (
                          <option key={tz} value={tz}>
                            {tz}
                          </option>
                        ))}
                      </select>
                    </div>

                     {schedule.map(({ day, isOff, timeSlots }) => (
                      <div key={day} style={{ borderBottom: "1px solid #ccc", padding: "10px 0" }}>
                        <div className="d-flex justify-content-between pt-1">
                          <div className="d-flex flex-column align-self-start">
                            <b>{day}</b>
                            <div className="d-flex">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={isOff}
                                  onChange={() => handleToggle(day)}
                                />
                                  <span className="slider"></span>
                                </label>
                              &nbsp;{t('closed')}
                            </div>
                          </div>

                          {!isOff && (
                            <div className="d-flex flex-column align-items-end pt-1">
                              {timeSlots.map((slot, index) => (
                                <TimeInputRow
                                  key={index}
                                  day={day}
                                  index={index}
                                  slot={slot}
                                  onChange={handleTimeChange}
                                  onRemove={removeTimeSlot}
                                  addTimeSlot={addTimeSlot}
                                />
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div
                    className=""
                    style={{
                      width: "80%",
                      margin: "25px 0%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      className="bg-primary text-white rounded-3 border-0 mx-4"
                      style={{
                        fontSize: "14px",
                        width: "23%",
                        padding: "10px",
                      }}
                      onClick={() => UploadApiOpeningHour()}
                    >
                      Update
                    </button>
                    <button
                      className="bg-primary text-white rounded-3 border-0 mx-4"
                      style={{
                        fontSize: "14px",
                        width: "23%",
                        padding: "10px",
                      }}
                      onClick={() => {
                        handleClose();
                        setIsHours(1);
                      }}
                    >
                      {t('close')}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )
        ) : (
          <div className="d-flex justify-content-center m-auto">
            <FiX
              color="black"
              size={25}
              style={{
                zIndex: 101,
                borderRadius: 10,
                position: "absolute",
                top: "4px",
                right: "10px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
            <div>
              {/* <h5 className="ms-5 ps-5 my-2">Update Gallery</h5> */}
              <h5 className="ms-5 ps-5 my-2">{t('imageGallery')}</h5>
              {showRes.length > 0 && (
                <h5
                  className="text-success ms-5 ps-5"
                  style={{ fontSize: "12px" }}
                >
                  {showRes}
                </h5>
              )}
              {IsUpload ? (
                <div
                  className="d-flex flex-wrap justify-content-center border p-2"
                  style={{
                    maxHeight: "350px",
                    overflowY: "auto",
                    cursor: "pointer",
                  }}
                  onClick={openInputFile}
                >
                  {Images.map((image, index) => (
                    <div key={index} className="position-relative">
                      <FiX
                        color="black"
                        size={20}
                        style={{
                          zIndex: 101,
                          borderRadius: 10,
                          position: "absolute",
                          backgroundColor: "#ECECEC",
                          padding: "4px",
                          top: "4px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          const newImages = Images.filter(
                            (img) => img !== image
                          );
                          setImages(newImages);
                          const newFiles = files.filter(
                            (file) => file !== files[index]
                          );
                          setfiles(newFiles);
                          if (newImages.length === 0) {
                            setIsUpload(false);
                          }
                        }}
                      />
                      <div onClick={(event) => event.stopPropagation()}>
                        <ModalImage
                          key={index}
                          hideDownload
                          className="gallary-upload m-2"
                          small={image}
                          large={image}
                          alt={`Gallery Image ${index + 1}`}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <img
                    src="/img/Placeholder.jpg"
                    alt="upload demo"
                    className="gallary-upload2"
                    style={{ cursor: "pointer" }}
                    onClick={openInputFile}
                  />
                </div>
              )}
              <input
                type="file"
                id="file"
                className="event-photo d-none"
                ref={inputFile}
                accept="image/png, image/jpeg"
                multiple
                onChange={handleImageChange}
              />
              <div
                className="my-3"
                style={{
                  // width: "340px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  type="button"
                  className="border-0 rounded-2 mx-2 w-100"
                  data-bs-toggle="button"
                  style={{
                    backgroundColor: "#0d6efd",
                    color: "white",
                    height: "45px",
                  }}
                  isOff={loading || files.length === 0}
                  onClick={() => {
                    UploadImage(files);
                  }}
                >
                  {loading ? (
                    <span>
                      <span className="spinner-border spinner-border-sm me-2"></span>{" "}
                      {t('uploading')}...
                    </span>
                  ) : (
                    t('upload')
                  )}
                </button>
                <button
                  type="button"
                  className="border-0 chat-btn rounded-2 mx-2 w-100"
                  data-bs-toggle="button"
                  style={{
                    color: "white",
                    height: "45px",
                  }}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  {t('cancel')}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const TimeInputRow = ({ day, index, slot, onChange, onRemove, addTimeSlot }) => (

  <div className="d-flex align-items-center mb-2" >
    <input
      type="time"
      value={slot.opening}
      onChange={(e) => onChange(day, index, "opening", e.target.value)}
      style={{ width: "45%", backgroundColor: "#ECECEC", borderColor: "#ECECEC" }}
      className="form-control"
      aria-label="Opening Time"
    />
    <span>&nbsp;to&nbsp;</span>
    <input
      type="time"
      value={slot.closing}
      onChange={(e) => onChange(day, index, "closing", e.target.value)}
      style={{ width: "45%", backgroundColor: "#ECECEC", borderColor: "#ECECEC" }}
      className="form-control"
      aria-label="Closing Time"
    />
    { index > 0 ? 
      <button onClick={() => onRemove(day, index)} className="btn btn-sm bg-transparent">
        <MdDeleteOutline />
      </button>
      :
      <button
        onClick={() => addTimeSlot(day)}
        className="btn btn-sm bg-transparent"
      >
        <MdAdd />
      </button>
    }
  </div>
);

export default PopupShare;